import Vue from 'vue'
import mainVue from './main.vue'

const defaults = {}

const MainConstructor = Vue.extend(mainVue)

let instance, currentBox

const types = {
  info: '文字题',
  text: '填空题',
  multitext: '多项填空题',
  select: '单选题',
  multiselect: '多选题',
  imageMultiselect: '图片多选题',
}

const defaultCallback = action => {
  if (currentBox) {
    let callback = currentBox.callback
    if (typeof callback === 'function') {
      callback(action)
    }
    if (currentBox.resolve) {
      if (action === 'confirm') {
        currentBox.resolve(action)
      } else if (currentBox.reject && (action === 'cancel' || action === 'close')) {
        currentBox.reject(action)
      }
    }
  }
}


const initInstance = () => {
  instance = new MainConstructor({
    el: document.createElement('div'),
  })

  instance.callback = defaultCallback
}

const showBox = () => {
  if (!instance) {
    initInstance()
  }

  instance.action = ''

  if (!instance.visible || instance.closeTimer) {
    if (currentBox) {
      let options = currentBox.options
      for (let prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop]
        }
      }

      if (options.callback === undefined) {
        instance.callback = defaultCallback
      }

      let oldCb = instance.callback
      instance.callback = (action, value) => {
        oldCb(action, value)
      }

      document.body.appendChild(instance.$el)

      Vue.nextTick(() => {
        instance.visible = true
      })
    }
  }
}

const generateDiagramData = data => {
  let nodeData = []
  let nodeOrder = []
  let linkData = []
  let diagram = []
  for (let key in data) {
    if (data.hasOwnProperty(key) && data[key]['id']) {
      let nextKey = Number(key) + 1
      nodeData.push({
        key: data[key]['id'],
        text: 'Q' + nextKey + ' ' + types[data[key]['type']], // 标题
        tooltip: data[key]['title'], // 悬浮框
        loc: 0 + ', ' + nextKey * 120, // 位置
      })
      nodeOrder[data[key]['id']] = key
    }
  }
  if (nodeData.length) {
    nodeOrder['end'] = nodeData.length
    nodeData.push({key: 'end', text: '结束答题', tooltip: '结束答题', loc: 0 + ', ' + (nodeData.length + 1) * 120})
  }

  for (let key in data) {
    if (data.hasOwnProperty(key) && data[key]['id']) {
      let nextKey = Number(key) + 1
      let nextNodeId = null
      if (data.hasOwnProperty(nextKey) && data[nextKey]['id']) {
        nextNodeId = data[nextKey]['id']
      } else {
        nextNodeId = 'end'
      }

      let fromId = data[key]['id']
      // jumpid => [title...]
      let jumpDataArray = getJumpData(data[key], nextNodeId)

      // 选项的跳转
      for (let jkey in jumpDataArray) {
        if (jumpDataArray.hasOwnProperty(jkey)) {
          let title = jumpDataArray[jkey]
          let link = {}
          let jumpNum = 0
          link.from = fromId
          link.text = title

          if (jkey !== '') {
            link.to = jkey
          } else {
            if (data[key]['jumpTargetId']) {
              link.to = data[key]['jumpTargetId']
            } else if (data.hasOwnProperty(nextKey) && data[nextKey]['id']) {
              link.to = data[nextKey]['id']
            } else {
              link.to = 'end'
            }
          }

          jumpNum = nodeOrder[link.to] - nodeOrder[link.from]

          link.curviness = getCurvinessNum(jumpNum)
          if (jumpNum > 1) {
            link.color = 'orange'
          }

          linkData.push(link)
        }
      }
    }
  }

  diagram['nodeDataArray'] = nodeData
  diagram['linkDataArray'] = linkData
  return diagram
}


const getJumpData = (data, nextNodeId) => {
  let jumpOptions = []
  // 有多种选项的题类
  if (data['type'] === 'select' || data['type'] === 'multiselect' || data['type'] === 'imageMultiselect') {
    for (let okey in data['options']) {
      if (data['options'].hasOwnProperty(okey)) {
        // 合并连接相同end node的option
        if (data['jumpTargetId'] === '' && ((data['options'][okey]['jumpTargetId'] === nextNodeId) && (nextNodeId === 'end'))) {
          data['options'][okey]['jumpTargetId'] = ''
        }
        if (jumpOptions.hasOwnProperty(data['options'][okey]['jumpTargetId'])) {
          jumpOptions[data['options'][okey]['jumpTargetId']] += ' + ' + data['options'][okey]['title']
        } else {
          jumpOptions[data['options'][okey]['jumpTargetId']] = data['options'][okey]['title']
        }
      }
    }
  } else {
    jumpOptions[data['jumpTargetId']] = [...'']
  }
  return jumpOptions
}

const getCurvinessNum = (jumpNum) => {
  if (jumpNum <= 1) {
    return 0
  }

  if (40 + 10 * jumpNum > 400) {
    return 450
  } else {
    return 40 + 10 * jumpNum
  }
}

const QuestionTreeBox = function (options, callback) {
  if (Vue.prototype.$isServer) return

  options = generateDiagramData(options)
  if (typeof options === 'object') {
    options = {
      diagramData: options,
    }
  } else if (options.callback && !callback) {
    callback = options.callback
  }


  currentBox = {
    options: _.merge({}, defaults, QuestionTreeBox.defaults, options),
    callback: callback,
  }

  showBox()
}

QuestionTreeBox.setDefaults = defaults => {
  QuestionTreeBox.defaults = defaults
}


QuestionTreeBox.open = (name, options) => {
  return QuestionTreeBox(_.merge({
    name,
  }, options))
}

QuestionTreeBox.close = () => {
  instance.doClose()
  instance.visible = false
  currentBox = null
}

QuestionTreeBox.destroy = () => {
  if (instance) {
    instance.$el.remove()
    instance.$destroy()
    instance = null
  }
}

export default QuestionTreeBox
export { QuestionTreeBox }



// WEBPACK FOOTER //
// ./src/views/question-editor/components/question-tree-box/src/main.js